import { useState, useEffect } from "react";
// * REDUX * //
import { useSelector } from "react-redux";
// * REQUETES * //
import { userSelector } from "store/models/userInfo";
import { fetchOneMenuByUrl } from "api/menu/menu";
import { findDataCustom } from "helpers/findDataCustom";
import { MenuView } from "components";

export default function Carte(props) {
  const [menu, setMenu] = useState(null);
  const [custom, setCustom] = useState(null);

  async function getOneMenu(url) {
    const menuResponse = await fetchOneMenuByUrl({ url });
    setMenu(menuResponse);
    setCustom(findDataCustom(menuResponse.Brand.Custom, menuResponse.Brand.id));
  }

  useEffect(() => {
    const url = props.match.params.url;
    if (url) {
      getOneMenu(url);
    }
  }, []);

  return (
    <div className="flex justify-center items-center w-full">
      <div className="w-full flex justify-center flex-col">
        <header className="flex justify-center mb-4 ">
          <img src={menu && menu.Brand.avatar} alt="brand-avatar" />
        </header>
        <div className="w-full">
          {custom && menu && <MenuView data={menu} custom={custom} />}
        </div>
      </div>
    </div>
  );
}
